/**
* DevExpress Dashboard (_chart-pane.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ChartAxisY, ChartSecondaryAxisY } from '../chart-axis';
export let chartSeries = { propertyName: 'series', modelName: 'Series', displayName: 'DashboardStringId.DescriptionItemSeries', array: true };
export let primaryAxisY = { propertyName: 'primaryAxisY', modelName: 'AxisY', displayName: 'DashboardWebStringId.Chart.PrimaryAxisY', type: ChartAxisY };
export let secondaryAxisY = { propertyName: 'secondaryAxisY', modelName: 'SecondaryAxisY', displayName: 'DashboardWebStringId.Chart.SecondaryAxisY', type: ChartSecondaryAxisY };
export let chartPaneName = { propertyName: 'name', modelName: '@Name', displayName: 'DashboardWebStringId.Chart.Name', simpleFormAdapterItem: 'textBoxEditor' };
export let chartPaneSerializationsInfo = [chartSeries, primaryAxisY, secondaryAxisY, chartPaneName];
